export default {
  expenseList: (state) => state.expenseList,
};
